<template>
  <div class="indicator_item">

    <div 
      class="indicator_item-title"
      @click="graphsActive = !graphsActive"
    >
      <img 
        :src="require('@/assets/img/menu/'+ item.icon +'')"
        class="indicator_item-img"
      />
      <span class="indicator_item-title">
        {{ item.title }}
      </span>
    </div>

    <!---список графика--->
    <transition name="fade">
      <div 
        class="indicator_item-graphs"
        :class="{'indicator_item-graphs-active': graphsActive }"
      >
        <div
          v-for="graph in item.graphs"
          :key="graph.id"
          class="checkbox_block"
        >
        <input 
          :id="'graph_checkbox-' + graph.id"
          class="graph_checkbox"
          type="checkbox"
          @change="change(graph.id)"
        />
          <label 
            :for="'graph_checkbox-' + graph.id"
            class="graph_checkbox-title"
          >
            {{ graph.label }}
          </label>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "FilterGraphIndicatorsListItem",
  data () {
    return {
      graphsActive: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    change (id) {
      this.$emit('change-graph', id)
    }
  }
}
</script>
<style lang="scss" scoped>
  .indicator_item {
    &-graphs {
      margin-left: 10px;
      max-height: 0;
      overflow: hidden;
      transition: all 1s;

      .checkbox_block {
        display: flex;
        align-items: center;
      }

      &-active {
        max-height: 1000px;
      }
      .graph_checkbox {
        margin: 15px 10px;
        transform:scale(1.7);
        cursor: pointer;

        &-title {
          margin-left: 10px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }

    &-title {
      display: flex;
      align-items: center;
      padding: 10px 0;
      font-weight: 600;
      cursor: pointer;
    }

    &-img {
      margin: 0px 10px;  
    }
  }
</style>